// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

const BASE_URL = config.ADJUSTMENT_JOBS_URL;

function launchAdjustmentJob(integrationId) {
    const baseUrl = BASE_URL + '/create_and_launch';
    console.log('launchAdjustmentJob', baseUrl, integrationId);
    return api.create(`${baseUrl}?integrationId=${integrationId}`);
}

function getAdjustmentJobStatus(integrationId) {
    const baseUrl = BASE_URL + '/get_status';
    console.log('getAdjustmentJobStatus', baseUrl, integrationId);
    return api.get(`${baseUrl}?integrationId=${integrationId}`);
}

function stopAdjustmentJob(integrationId: string): any {
    const baseUrl = BASE_URL + '/stop';
    return api.create(`${baseUrl}?integrationId=${integrationId}`);
}

function restartAdjustmentJob(integrationId: string): any {
    const baseUrl = BASE_URL + '/restart';
    return api.create(`${baseUrl}?integrationId=${integrationId}`);
}

function getAllAdjustmentJobs(): any {
    const baseUrl = BASE_URL;
    return api.get(baseUrl);
}

export {
    launchAdjustmentJob,
    getAdjustmentJobStatus,
    stopAdjustmentJob,
    restartAdjustmentJob,
    getAllAdjustmentJobs,
};
